import gql from 'graphql-tag'

export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  query GetOrganizationOrderItemTemplates($organizationSlug: String!) {
    getOrganizationOrderItemTemplates(organizationSlug: $organizationSlug) {
      name
      price
      currency
      venueSection
      venueId
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES = gql`
  query GetOrganizationOrderItemTemplatesAndVenues($organizationSlug: String!) {
    getOrganizationOrderItemTemplates(organizationSlug: $organizationSlug) {
      id
      name
      price
      currency
      venueSection
      venueId
      membership
      prepaidCoupon
      ticketSeller
      salesChannel
      orderItems {
        id
        initialQuantity
        prepaidCoupon
        quantity
        membership
      }
      venue {
        id
        name
      }
    }
    getOrganizationVenues(organizationSlug: $organizationSlug) {
      id
      publicName
      type
      organizationVenues {
        venueId
        venue {
          id
          name
          seats
          predefinedSections
        }
      }
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES_AND_PROMO_CODES = gql`
  query GetOrganizationOrderItemTemplatesAndVenuesAndPromoCodes($organizationSlug: String!) {
    getOrganizationOrderItemTemplates(organizationSlug: $organizationSlug) {
      id
      name
      price
      currency
      venueSection
      venueId
      membership
      prepaidCoupon
      ticketSeller
      salesChannel
      orderItems {
        id
        initialQuantity
        prepaidCoupon
        quantity
        membership
      }
      venue {
        id
        name
      }
    }
    getOrganizationVenues(organizationSlug: $organizationSlug) {
      id
      publicName
      type
      organizationVenues {
        venueId
        venue {
          id
          name
          seats
          predefinedSections
        }
      }
    }
    getAllOrganizationPromoCodes(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`
export const CREATE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation CreateOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateInput: OrderItemTemplateInput!
  ) {
    createOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateInput: $orderItemTemplateInput
    ) {
      id
      name
      price
    }
  }
`
export const UPDATE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation UpdateOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateInput: OrderItemTemplateInput!
  ) {
    updateOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateInput: $orderItemTemplateInput
    ) {
      id
      name
      price
    }
  }
`
export const DELETE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation DeleteOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateId: ID!
  ) {
    deleteOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateId: $orderItemTemplateId
    )
  }
`
